import React, { createContext, useState, useEffect } from "react";

export const MediaContext = createContext();

export const MediaProvider = ({ children }) => {
  const [screenSize, setScreenSize] = useState(window.innerWidth);

  useEffect(() => {
    window.addEventListener("resize", () => setScreenSize(window.innerWidth));
  }, []);

  return (
    <MediaContext.Provider value={{ screenSize }}>
      {children}
    </MediaContext.Provider>
  );
};
